import axios from "axios";
import apiClient from "../helpers/apiClient";

const API = `/api/v2/user`
const api = apiClient();

export const getInfoData = () => api.get(`${API}/info`);
export const getInfoDataByUserId = (id) => api.get(`${API}/info-by-id/${id}`);
export const getInfoDataByAlmacenId = (id) => getInfoDataByUserId(id);
export const getUserInfoByUserId = (id) => api.get(`/api/users/${id}/user-info`);
export const getCheckingData = () => api.get(`${API}/checkin`);
export const getCheckingDataByHostId = (id) => api.get(`${API}/checkin/evaluation/${id}`);
export const getCheckingDataByAlmacenId = (id) => getCheckingDataByHostId(id);
export const updateShiftConfig = (data) => api.put(`${API}/shifts`, data);
export const updateResto = async (data, opts = {}) => {
    if (typeof FormData !== "undefined" && data instanceof FormData) {
        const response = await axios.put(`${API}/update-resto`, data, {
            ...opts,
            headers: {
                ...(opts.headers || {}),
            },
        });
        return response?.data;
    }

    return api.put(`${API}/update-resto`, data, opts);
};
export const updateProfile = (data) => api.put(`${API}/update-profile`, data);
export const acceptTerms = (id, term = true) => api.post(`/api/users/accept/terms`, { id, term });

export const changeAvatar = (file, type) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", "owner");

    console.log("[Avatar] changeAvatar called", {
        type,
        fileName: file?.name,
        fileType: file?.type,
        fileSize: file?.size,
        hasFile: formData.has("file"),
        formDataFile: formData.get("file"),
    });

    return api.post(`${API}/avatar-change?type=${encodeURIComponent(type)}`, formData);
};
